import { useEffect, useState } from "react";
import api from "../../services/axiosInstance";

export default function EditTestimonials() {
  const [testimonials, setTestimonials] = useState([]);

  // Fetch testimonials from backend
  useEffect(() => {
    api
      .get("/testimonials")
      .then((response) => setTestimonials(response.data.testimonials))
      .catch((error) => console.error("Error fetching testimonials:", error));
  }, []);

  // Handle input changes
  const handleChange = (index, field, value) => {
    const newTestimonials = [...testimonials];
    newTestimonials[index][field] = value;
    setTestimonials(newTestimonials);
  };

  // Save to backend
  const handleSave = () => {
    api
      .post("/testimonials/edit", testimonials) // Axios automatically JSON.stringify
      .then((res) => alert(res.data.message))
      .catch((err) => console.error(err));
  };

  // Add a new testimonial
  const handleAdd = () => {
    setTestimonials([
      ...testimonials,
      { name: "", text: "" } // empty fields for new testimonial
    ]);
  };

  // Delete a testimonial
  const handleDelete = (index) => {
    const newTestimonials = [...testimonials];
    newTestimonials.splice(index, 1);
    setTestimonials(newTestimonials);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6">Edit Testimonials</h2>

      {testimonials.map((item, index) => (
        <div key={index} className="mb-4 p-4 border rounded-lg">
          <input
            className="w-full mb-2 p-2 border rounded"
            placeholder="Name"
            value={item.name}
            onChange={(e) => handleChange(index, "name", e.target.value)}
          />
          <textarea
            className="w-full p-2 border rounded"
            rows={4}
            placeholder="Testimonial text"
            value={item.text}
            onChange={(e) => handleChange(index, "text", e.target.value)}
          />
          <button
            onClick={() => handleDelete(index)}
            className="mt-2 px-3 py-1 bg-red-600 text-white rounded"
          >
            Delete
          </button>
        </div>
      ))}

      <div className="flex gap-4 mt-4">
        <button
          onClick={handleAdd}
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          Add New
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-emerald-600 text-white rounded"
        >
          Save All
        </button>
      </div>
    </div>
  );
}
